import { Helmet } from "react-helmet-async";
import PageHeader from "../../components/PageHeader";
import { filter } from "lodash";
import { sentenceCase } from "change-case";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import CModel from "../../components/CModel/CModel";
import Papa from "papaparse";
import {
  Card,
  Stack,
  Paper,
  Button,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Breadcrumbs,
  Snackbar,
  Alert,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
// components
import Label from "../../components/label";
import Iconify from "../../components/iconify";
import Scrollbar from "../../components/scrollbar";
// sections
import { UserListHead, UserListToolbar } from "../../sections/@dashboard/user";
// mock
import { getUsers } from "../../feature/userSlice";
import { useSelector } from "react-redux";
import { deleteInventory, getInventory } from "../../feature/inventorySlice";
import { HomeRounded } from "@mui/icons-material";
import ApiCall from "../../utils/apicall";
import { hasPermission, PERMISSIONS } from "../../utils/hasPermission";
import InventoryImportDialog from "../../components/InventoryImport/InventoryImportDialog";
// 2026-09-05 reconciliation: dead import removed. GeneralInventoryPanel was
// imported here but never referenced, so webpack tree-shook it and it never
// entered the deployed bundle - which is also why it is absent from the
// source map this tree was recovered from. Removing the unused import is
// behaviour-neutral: the module was not in the shipping output either way.
import EquipmentPanel from "../../components/InventoryImport/EquipmentPanel";
import StandardsPanel from "../../components/InventoryImport/StandardsPanel";
import ImportedItemsPanel from "../../components/InventoryImport/ImportedItemsPanel";

import SmartTable from "../../components/SmartTable/SmartTable";
const TABLE_HEAD = [
  {
    id: "ediStdNomenclature",
    label: "EDI Std Nomenclature",
    alignRight: false,
  },
  { id: "itemType", label: "Item Type", alignRight: false },
  { id: "shape", label: "Shape", alignRight: false },
  { id: "weight", label: "Weight", alignRight: false },
  { id: "depth", label: "Depth", alignRight: false },
  {
    id: "orderArrivedInFull",
    label: "Order Arrived In Full",
    alignRight: false,
  },
  { id: "orderArrivedCMTR", label: "Order Arrived In CMTR", alignRight: false },
  { id: "quantity", label: "Quantity", alignRight: false },
  { id: "" },
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

export default function Users(props) {
  const dispatch = useDispatch();
  const open = false;
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("asc");
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState("name");
  const [filterName, setFilterName] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedRow, setSelectedRow] = useState("");
  const [openModel, setOpenModel] = useState(false);
  const [openUpdateModel, setOpenUpdateModel] = useState(false);
  const { inventory, isInventoryLoading } = useSelector(
    (state) => state.inventorySlice
  );
  const [inventories, setIntventories] = useState([]);
  const [importOpen, setImportOpen] = useState(false);
  const [importMsg, setImportMsg] = useState(null);
  const [view, setView] = useState("steel");
  const [generalRefresh, setGeneralRefresh] = useState(0);
  const { loginUser } = useSelector((state) => state.userSlice);

  const { permissions: userPermissions } = loginUser.decodedToken;
  const canAddInventory = hasPermission(
    userPermissions,
    PERMISSIONS.ADD_INVENTORY
  );
  const canEditInventory = hasPermission(
    userPermissions,
    PERMISSIONS.EDIT_INVENTORY
  );
  const canDeleteInventory = hasPermission(
    userPermissions,
    PERMISSIONS.DELETE_INVENTORY
  );
  const canExportInventory = hasPermission(
    userPermissions,
    PERMISSIONS.EXPORT_INVENTORY
  );
  const canViewInventoryList = hasPermission(
    userPermissions,
    PERMISSIONS.VIEW_INVENTORY
  );

  // Note: previously fetched /inventory/export on mount (Codex CRITICAL —
  // pulled export-grade dataset for non-export users). Fix: defer until the
  // user clicks Export AND has EXPORT_INVENTORY permission. Backend must
  // enforce the same check on the endpoint itself.
  const fetchInventories = async () => {
    if (!canExportInventory) return null;
    try {
      const response = await ApiCall.get("/inventory/export");
      setIntventories(response.data.data);
      return response.data.data;
    } catch (error) {
      console.error("Error fetching inventories:", error);
      return null;
    }
  };

  const handleExport = async () => {
    if (!canExportInventory) {
      console.warn("Export blocked: missing EXPORT_INVENTORY permission");
      return;
    }
    let data = inventories;
    if (!data || data.length === 0) {
      data = await fetchInventories();
      if (!data) return;
    }
    const customCsvData = data.map((inventory) => ({
      ediStdNomenclature: inventory.ediStdNomenclature,
      aiscManualLabel: inventory.aiscManualLabel,
      shape: inventory.shape,
      weight: inventory.weight,
      depth: inventory.depth,
      grade: inventory.grade,
      poNumber: inventory.poNumber,
      heatNumber: inventory.heatNumber,
      orderArrivedInFull: inventory.orderArrivedInFull,
      orderArrivedCMTR: inventory.orderArrivedCMTR,
      itemType: inventory.itemType,
      lengthReceivedFoot: inventory.lengthReceivedFoot,
      lengthReceivedInch: inventory.lengthReceivedInch,
      quantity: inventory.quantity,
      poPulledFromNumber: inventory.poPulledFromNumber,
      lengthUsedFoot: inventory.lengthUsedFoot,
      lengthUsedInch: inventory.lengthUsedInch,
      lengthRemainingFoot: inventory.lengthRemainingFoot,
      lengthRemainingInch: inventory.lengthRemainingInch,
    }));
    const csvData = Papa.unparse(customCsvData, { header: true });
    const blob = new Blob([csvData], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "inventories.csv";
    a.click();

    URL.revokeObjectURL(url);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = inventory.map((n) => n.ediStdNomenclature);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  function applySortFilter(array, comparator, query) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    if (query) {
      return filter(
        inventory,
        (_inv) =>
          _inv.ediStdNomenclature.toLowerCase().indexOf(query.toLowerCase()) !==
          -1
      );
    }
    return stabilizedThis.map((el) => el[0]);
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - inventory.length) : 0;
  const filteredUsers = applySortFilter(
    inventory,
    getComparator(order, orderBy),
    filterName
  );
  const isNotFound = !filteredUsers.length && !!filterName;

  const handleDelete = (id) => {
    dispatch(deleteInventory(id));
  };
  const handleOpenModel = () => {
    setOpenModel(!open);
  };

  useEffect(() => {
    dispatch(getUsers());
    dispatch(getInventory());
  }, [dispatch]);
  return (
    <>
      <Helmet>
        <title>Inventory | SFM</title>
      </Helmet>
      <InventoryImportDialog
        open={importOpen}
        onClose={() => setImportOpen(false)}
        onImported={(n) => { setImportMsg(`Imported ${n} item(s).`); setGeneralRefresh((k) => k + 1); setView("imported"); }}
      />
      <Snackbar open={!!importMsg} autoHideDuration={5000} onClose={() => setImportMsg(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}>
        <Alert severity="success" onClose={() => setImportMsg(null)}>{importMsg}</Alert>
      </Snackbar>
      {openModel ? (
        <CModel
          isLoading={isInventoryLoading}
          open={openModel}
          setOpen={setOpenModel}
          filter={"add-inventory"}
        />
      ) : (
        ""
      )}
      {openUpdateModel ? (
        <CModel
          open={openUpdateModel}
          isLoading={isInventoryLoading}
          data={selectedRow}
          setOpen={setOpenUpdateModel}
          filter={"update-inventory"}
        />
      ) : (
        ""
      )}
      {canViewInventoryList && (
        <Container>
          <PageHeader
            breadcrumbs={[{ label: "Inventory" }]}
            title="Inventory"
            action={<div style={{ display: "flex", gap: "10px" }}>
              {canAddInventory && (
                <Button
                  onClick={() => setImportOpen(true)}
                  variant="outlined"
                  startIcon={<Iconify icon="ph:upload-fill" />}
                >
                  Import Inventory
                </Button>
              )}
              {canAddInventory && (
                <Button
                  onClick={handleOpenModel}
                  variant="contained"
                  startIcon={<Iconify icon="eva:plus-fill" />}
                >
                  New Inventory
                </Button>
              )}
            </div>}
            guide={{
              why: "Know what material and consumables you have on hand — so you don't over-order or run short mid-job.",
              who: "Shop and yard staff tracking material; purchasing checking stock before ordering.",
              what: "Your shop inventory: stock, consumables, and equipment, by category.",
              how: "Add items or import a list; record quantities and categories.",
              when: "When stock comes in or is consumed, and during inventory counts.",
              standard: "AISC 207-25 §2.6",
            }}
          />

          <ToggleButtonGroup exclusive size="small" value={view} sx={{ mb: 2 }}
            onChange={(_, v) => { if (v) setView(v); }}>
            <ToggleButton value="steel">Steel Stock</ToggleButton>
            <ToggleButton value="imported">Imported Items</ToggleButton>
            <ToggleButton value="general">Governing Standards</ToggleButton>
            <ToggleButton value="equipment">Equipment</ToggleButton>
          </ToggleButtonGroup>

          {view === "steel" ? (
          <Card>
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <UserListToolbar
                label={"Search inventory..."}
                numSelected={selected.length}
                filterName={filterName}
                onFilterName={handleFilterByName}
              />
              <TablePagination
                rowsPerPageOptions={[10, 25]}
                component="div"
                count={inventory.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </div>

            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <SmartTable tableId="inventory" lockedColumns={["EDI Std Nomenclature"]}>
                  <UserListHead
                    // order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    rowCount={inventory.length}
                    numSelected={selected.length}
                    onRequestSort={handleRequestSort}
                    onSelectAllClick={handleSelectAllClick}
                  />
                  <TableBody>
                    {filteredUsers.length === 0 && !isNotFound && (
                      <TableRow>
                        <TableCell
                          align="center"
                          colSpan={TABLE_HEAD.length}
                          sx={{ py: 4 }}
                        >
                          {/* Codex WARNING fix: empty state had no domain
                              context or recovery action. Now names the
                              concept and offers a permission-gated CTA. */}
                          <Stack alignItems="center" spacing={1.5}>
                            <Typography variant="h6">No inventory items yet</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 480 }}>
                              Track stock by adding the steel members and consumables you receive.
                              Each entry can be tied to a heat number for AWS D1.1 / ISO 3834
                              traceability.
                            </Typography>
                            {canAddInventory && (
                              <Button
                                variant="contained"
                                onClick={handleOpenModel}
                                startIcon={<Iconify icon="eva:plus-fill" />}
                                sx={{ mt: 1 }}
                              >
                                Add inventory item
                              </Button>
                            )}
                          </Stack>
                        </TableCell>
                      </TableRow>
                    )}
                    {filteredUsers
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row) => {
                        const {
                          id,
                          ediStdNomenclature,
                          shape,
                          weight,
                          depth,
                          orderArrivedInFull,
                          orderArrivedCMTR,
                          itemType,
                          quantity,
                        } = row;

                        // const selectedUser = selected.indexOf(ediStdNomenclature) !== -1;
                        return (
                          <TableRow hover key={id} tabIndex={-1}>
                            <TableCell
                              component="th"
                              scope="row"
                              padding="none"
                            >
                              <Stack direction="row" alignItems="center">
                                <Typography
                                  variant="subtitle2"
                                  sx={{ padding: "0px 15px" }}
                                  noWrap
                                >
                                  {ediStdNomenclature}
                                </Typography>
                              </Stack>
                            </TableCell>
                            <TableCell align="left">{itemType}</TableCell>
                            <TableCell align="left">{shape}</TableCell>
                            <TableCell align="left">{weight}</TableCell>
                            <TableCell align="left">{depth}</TableCell>
                            <TableCell align="left">
                              <Label
                                color={
                                  orderArrivedInFull === true
                                    ? "success"
                                    : "error"
                                }
                              >
                                {sentenceCase(
                                  orderArrivedInFull ? "Yes" : "No"
                                )}
                              </Label>
                            </TableCell>
                            <TableCell align="left">
                              <Label
                                color={
                                  orderArrivedCMTR === true
                                    ? "success"
                                    : "error"
                                }
                              >
                                {sentenceCase(
                                  orderArrivedCMTR ? "Yes" : "No"
                                )}
                              </Label>
                            </TableCell>
                            <TableCell align="left">{quantity}</TableCell>
                            <TableCell
                              align="right"
                              style={{ display: "flex" }}
                            >
                              {canEditInventory && (
                                <MenuItem
                                  onClick={() => {
                                    setSelectedRow(row);
                                    setOpenUpdateModel(!openUpdateModel);
                                  }}
                                >
                                  <Iconify icon={"eva:edit-fill"} />
                                </MenuItem>
                              )}

                              {canDeleteInventory && (
                                <MenuItem
                                  sx={{ color: "error.main" }}
                                  onClick={() => handleDelete(id)}
                                >
                                  <Iconify icon={"eva:trash-2-outline"} />
                                </MenuItem>
                              )}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>

                  {isNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                          <Paper
                            sx={{
                              textAlign: "center",
                            }}
                          >
                            <Typography variant="h6" paragraph>
                              Not found
                            </Typography>

                            <Typography variant="body2">
                              No results found for &nbsp;
                              <strong>&quot;{filterName}&quot;</strong>.
                              <br /> Try checking for typos or using complete
                              words.
                            </Typography>
                          </Paper>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </SmartTable>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[10, 25]}
              component="div"
              count={inventory.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Card>
          ) : view === "imported" ? (
            <ImportedItemsPanel refreshKey={generalRefresh} />
          ) : view === "general" ? (
            <StandardsPanel />
          ) : (
            <EquipmentPanel />
          )}
        </Container>
      )}
    </>
  );
}
